import { Column } from "@allxsmith/bestax-bulma";
import React from "react";


export default function Figure(props) {
  return (
    <Column>
      {props.label+": "}
      {props.loaded && props.value != null
        ? props.round ? props.value.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })
        : props.value
        : "Loading..."}
    </Column>
  );
}